function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M54.9899 17.2607C51.9395 5.10896 39.616 -2.26908 27.4643 0.781281C17.968 3.16514 11.0727 11.3726 10.3622 21.1376C3.6195 22.2496 -0.94521 28.617 0.166742 35.3597C1.15522 41.3541 6.34931 45.744 12.4245 45.7199H22.7359V41.5954H12.4245C7.86869 41.5954 4.17542 37.9021 4.17542 33.3463C4.17542 28.7905 7.86869 25.0972 12.4245 25.0972C13.5635 25.0972 14.4868 24.1739 14.4868 23.0349C14.4765 12.7842 22.778 4.46605 33.0287 4.45587C41.9021 4.44697 49.5407 10.7202 51.2571 19.4259C51.4266 20.2952 52.1321 20.9592 53.0101 21.0757C58.6481 21.8786 62.5676 27.0999 61.7648 32.7378C61.0439 37.8004 56.7214 41.5699 51.6077 41.5954H43.3586V45.7199H51.6077C59.5805 45.6958 66.024 39.2131 65.9998 31.2403C65.9797 24.6036 61.437 18.8356 54.9899 17.2607Z",
  fill: "#565656"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M31.583 25.6953L23.3339 33.9444L26.2417 36.8522L30.985 32.1296V51.9068H35.1095V32.1296L39.8321 36.8522L42.7399 33.9444L34.4908 25.6953C33.6864 24.8957 32.3874 24.8957 31.583 25.6953Z",
  fill: "#565656"
});

function SvgCloudUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 52,
    viewBox: "0 0 66 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/CloudUpload.b0529010.svg";
export { ForwardRef as ReactComponent };